import { TagsActions } from "../reducers/tags";

export const { retrieveAllTags, loadTags } = TagsActions;
